import './style.scss';
import ioaBg from '../../../../assets/img/ioa-bg.png';
import ioaIconTip from '../../../../assets/svg/ioa-icon-tip.svg';
import ioaFailBg from '../../../../assets/img/403.png';
import { Header } from '../../../component/header';
import getFormatMessage from '../../../../locales/get-format-message';
// import getFormatMessage from '../../../../locales/get-format-message';

export const NoPermission = () => {
  return (
    <div className="c-page-no-permission">
      <Header isTransparent={true} />;
      <div
        className="c-page-ioa-content"
        style={{ backgroundImage: `url(${ioaBg})` }}
      >
        <div className="success-content content">
          <div className="per-icon-box">
            <img className="ioa-icon-tip" src={ioaIconTip} />
          </div>
          <div className="content-inner">
            <img src={ioaFailBg} />
            <div className="text">
              <span className="title-403">403</span>
            </div>
            <div className="footer-tip">
              <div> {getFormatMessage('no_page_permission_line_one')} </div>
              <div> {getFormatMessage('no_page_permission_line_two')} </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NoPermissionCard = (props: {
  title?: string;
  subTitle?: string;
}) => {
  const { title, subTitle } = props;
  return (
    <div className="c-page-no-permission-card">
      <div className="success-content content">
        <div className="content-inner">
          <img src={ioaFailBg} />
          <div className="footer-tip">
            <span className="footer-tip-bold">
              {title || getFormatMessage('no_page_permission_line_one')}
            </span>

            <span>
              {subTitle || getFormatMessage('no_page_permission_line_two')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
